module.exports = __webpack_public_path__ + "img/bannow_medium.1ed0957a.png";